const mutations = {
  SET_TABLE_DATA(state, { data }) {
    state.tableData = data
  },
  SET_CHART_DATA(state, { data }) {
    state.chartData = data
  },
  SET_MIDDLE_LANG(state, { middleLang }) {
    state.middleLang = middleLang
  },
  SET_BP_LIST(state, { BPList }) {
    state.BPList = BPList
  },
  SET_SELECTED_IO_ID(state, { Id }) {
    state.selectedIOId = Id
  },
  SET_TODAY(state, { today }) {
    state.today = today
  },
}

export default mutations
